export function MonochromeCrispyVoiceLogo({ className }: { className?: string }) {
    return (
        <svg
            width='76.996002mm'
            height='78.209mm'
            viewBox='0 0 76.996002 78.209'
            fill='currentColor'
            className={className}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M 76.993747,26.14083 60.026019,42.56616 43.256728,59.34339 26.746728,42.7937 43.526603,26.14083 H 17.06827 L 0,43.20645 l 29.696832,29.67302 0.05556,0.0476 c 3.278187,3.14589 7.580312,5.01121 12.117916,5.25462 4.537604,0.24342 9.014354,-1.15093 12.610042,-3.92641 0.259291,-0.18521 22.516047,-22.4499 22.516047,-22.4499 l -0.005,-25.66458 z'
                style={{ strokeWidth: 0.264583 }}
            />
            <path
                d='M 43.47104,26.07468 59.957228,42.73814 60.004848,16.74547 43.259369,0 30.331827,12.92754 Z'
                style={{ strokeWidth: 0.264583 }}
            />
        </svg>
    );
}
